import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { tagAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tagAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    alignItems: 'center',
    borderRadius: 'base',
    display: 'inline-flex',
    gap: 1,
    fontWeight: 'regular',
  },
  label: {
    lineHeight: 'inherit',
  },
  closeButton: {
    ml: 0,
    height: '1em',
    width: '1em',
  },
});

const sizes = {
  xs: {
    container: {
      fontSize: 'xs',
      gap: 0.25,
      lineHeight: 4,
      px: 1,
      py: 0.5,
    },
    closeButton: {
      fontSize: 'sm',
    },
  },
  sm: {
    container: {
      fontSize: 'sm',
      gap: 0.5,
      lineHeight: 4,
      px: 1.5,
      py: 1,
    },
    closeButton: {
      fontSize: 'md',
    },
  },
  md: {
    container: {
      fontSize: 'md',
      lineHeight: 5,
      px: 2,
      py: 1,
    },
    closeButton: {
      fontSize: 'lg',
    },
  },
  lg: {
    container: {
      fontSize: 'lg',
      lineHeight: 6,
      px: 2.5,
      py: 1,
    },
    closeButton: {
      fontSize: 'xl',
    },
  },
  xl: {
    container: {
      fontSize: 'xl',
      lineHeight: 7,
      gap: 1.5,
      px: 3,
      py: 1,
    },
    closeButton: {
      fontSize: 'xl',
    },
  },
};

export const tagTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    size: 'sm',
  },
  sizes,
});
